import { projectFirestore } from '../../firebase/config'
import { useParams, Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useTheme } from '../../hooks/useTheme'

// styles
import './Plan.css'

export default function Plan() {
    const { id } = useParams()
    const { mode } = useTheme()

    const [lesson, setLesson] = useState(null)
    const [isPending, setIsPending] = useState(false)
    const [error, setError] = useState(false)


    useEffect(()=> {
        setIsPending(true)

        projectFirestore.collection('lessons').doc(id).get().then((doc) => {
            if (doc.exists) {
                setIsPending(false)
                setLesson(doc.data())
            } else {
                setIsPending(false)
                setError('Could not find that entry')
            }
        })

    }, [id])


    return (
        <div className={`lesson ${mode}`}>
            {error && <p className='error'>{error}</p>}
            {isPending && <p className='loading'>Loading...</p>}
            {lesson && (
                <>
                    <div className='breadcrumbs'>
                        <Link to="/">
                            <div className='link-crumb'>/Home </div>
                        </Link>
                        <Link to="/lessons">
                            <div className='link-crumb'> /Lesson Plans </div>
                        </Link>
                        <div className='link-crumb'> /{lesson.title}</div>
                    </div>
                    <h2 className='page-title'>{lesson.title}</h2>
                    <img src={lesson.icon} alt={`${lesson.title} icon`} className='icon'/>
                    <p>{lesson.date}</p>
                    <p className='grades'>Grades: {lesson.grade}</p>
                    {lesson.demo_image &&
                    <div>
                        <img src={lesson.demo_image} alt={lesson.demo_img_text} />
                        <p>{lesson.demo_img_text}</p>
                    </div>
                    }
                    {lesson.target && 
                    <div className='row'>
                        <h4>Learning Target (What the students will learn in this lesson):</h4>
                        <p>{lesson.target}</p>
                    </div>}
                    {lesson.demo_image_2 &&
                    <div>
                        <img src={lesson.demo_image_2} alt={lesson.demo_img_text_2} />
                        <p>{lesson.demo_img_text_2}</p>
                    </div>
                    }
                    {lesson.question &&
                    <div className='row'>
                        <h4>Essential Question: (What are the most important concepts my students should learn from this unit):</h4>
                        <ul>
                            {lesson.question.map((q, num) => 
                                <li key={num}>{q}</li>)}
                        </ul>
                    </div>
                    }
                    {lesson.objective && 
                    <div className='row'>
                        <h4>Learning Objective (outcome statement that captures specifically what knowledge, skills, attitudes learners should be able to exhibit following instruction):</h4>
                        <p>{lesson.objective}</p>
                    </div>}
                    {lesson.standards &&
                    <div className='row'>
                        <h4>Next Generation Standards Met:</h4>
                        <ul>
                            {lesson.standards.map((standard, num) => 
                                <li key={num}>{standard}</li>)}
                        </ul>
                    </div>
                    }
                    {lesson.vocab &&
                    <div className='row'>
                        <h4>Target Vocabulary:</h4>
                        <ul>
                            {lesson.vocab.map((word, num) => 
                                <li key={num}>{word}</li>)}
                        </ul>
                    </div>
                    }
                    {lesson.materials &&
                    <div className='row'>
                        <h4>Materials/Resources/Technology:</h4>
                        <ul>
                            {lesson.materials.map((material, num) => 
                                material.link ? 
                                <li key={num}><a href={material.link} target="_blank" rel="noreferrer">{material.name}</a></li>:
                                <li key={num}>{material.name}</li>)}
                        </ul>
                    </div>
                    }
                    {lesson.handouts &&
                    <div className='row'>
                        <h4>Class Handouts:</h4>
                        <ul>
                            {lesson.handouts.map((handout, num) => 
                               <img src={handout} alt={`handout ${num + 1}`} />
                               )}
                        </ul>
                    </div>
                    }
                    {lesson.youtube_id &&
                    <div>
                        <h4>{lesson.youtube_title}</h4>
                        <iframe className='video'
                                title='Youtube player'
                                sandbox='allow-same-origin allow-forms allow-popups allow-scripts allow-presentation'
                                src={`https://youtube.com/embed/${lesson.youtube_id}?autoplay=0`}>
                        </iframe>
                    </div>

                    }
                    {lesson.differentiation &&
                    <div className='row'>
                        <h4>Differentiation (Content, Process or Product)  (is how students will learn, not what they will do):</h4>
                        <ul>
                            {lesson.differentiation.map((word, num) => 
                                <li key={num}><b>{word.title}:</b> {word.ability}</li>)}
                        </ul>
                    </div>
                    }
                    {
                        lesson.connection &&
                        <div className='row'>
                            <h4>Connection to (interdisciplinary): Real world, Science, S.S., Religion, etc. ...</h4>
                            <p>{lesson.connection}</p>
                        </div>
                    }
                </>
            )}
             <Link to="/lessons">
                <div className='link'>&#8592; Back to all Lesson Plans</div>
            </Link>
        </div>
    )
}